import React from 'react';
import { Layout } from '@/components/Layout/Layout';

type Props = {
  children: React.ReactNode;
};

export const SettingsLayout = ({ children }: Props) => {
  return (
    <Layout>
      <div className="flex items-center justify-center p-3 pt-10">
        <div className="w-full max-w-lg rounded-3xl bg-white p-6 drop-shadow lg:p-8">
          {children}
        </div>
      </div>
    </Layout>
  );
};
